import React from 'react';

import { SingpassLandingPage } from './screens/SingpassLandingPage';
import AddressPage from './screens/AddressPage';
import { PersonalInfoPage } from './screens/PersonalInfoPage';
import { PoaUploadPage } from './screens/PoaUploadPage';
import SuccessPage from './screens/SuccessPage';
import { PoiPoaUploadPage } from './screens/PoiPoaUploadPage';
/* 
  Never make this JumioVerification import using React Lazy, 
  Back button will froze the app.
*/
import JumioVerification from '../../../../src/screens/jumio-flow';
import { PoaSelectedUploadPage } from './screens/PoaSelectedUploadPage';
import { SgOddFlowType, SgOddScreenName, SgOddScreens } from './types';

export const SG_ODD_SCREEN_NAMES: Record<SgOddScreenName, SgOddScreenName> = {
  landing_page: 'landing_page',
  address_page: 'address_page',
  success_page: 'success_page',
  personal_info_page: 'personal_info_page',
  poa_upload_page: 'poa_upload_page',
  poa_selected_upload_page: 'poa_selected_upload_page',
  poi_poa_upload_page: 'poi_poa_upload_page',
  jumio_verification: 'jumio_verification'
};

export const SG_ODD_FLOW_TYPES: Record<SgOddFlowType, SgOddFlowType> = {
  SINGPASS: 'SINGPASS',
  NRIC: 'NRIC',
  NRIC_PR: 'NRIC_PR',
  JUMIO: 'JUMIO',
  FIN: 'FIN'
} as const;

export const SG_ODD_SCREENS: SgOddScreens = {
  landing_page: {
    name: SG_ODD_SCREEN_NAMES.landing_page,
    component: <SingpassLandingPage />
  },
  address_page: {
    name: SG_ODD_SCREEN_NAMES.address_page,
    component: <AddressPage />
  },
  success_page: {
    name: SG_ODD_SCREEN_NAMES.success_page,
    component: <SuccessPage />
  },
  personal_info_page: {
    name: SG_ODD_SCREEN_NAMES.personal_info_page,
    component: <PersonalInfoPage />
  },
  poa_upload_page: {
    name: SG_ODD_SCREEN_NAMES.poa_upload_page,
    component: <PoaUploadPage />
  },
  poa_selected_upload_page: {
    name: SG_ODD_SCREEN_NAMES.poa_selected_upload_page,
    component: <PoaSelectedUploadPage />
  },
  poi_poa_upload_page: {
    name: SG_ODD_SCREEN_NAMES.poi_poa_upload_page,
    component: <PoiPoaUploadPage />
  },
  jumio_verification: {
    name: SG_ODD_SCREEN_NAMES.jumio_verification,
    component: <JumioVerification />
  }
};
